module.exports = __webpack_public_path__ + "images/businesslease11cf215cbbc11048095dd64b63c04605.png";